import { supabase } from '@/lib/supabase'

export type RewardsUsdtBrlRateSyncResponse = {
  ok: boolean
  rate: number
  source: string
  fetched_at: string
}

export async function syncRewardsUsdtBrlRate(): Promise<RewardsUsdtBrlRateSyncResponse> {
  const { data, error } = await supabase.functions.invoke('rewards-usdt-brl-rate-sync', { body: {} as any })
  if (error) throw error
  return (Array.isArray(data) ? (data as any)[0] : (data as any)) as RewardsUsdtBrlRateSyncResponse
}

